import { Component, ElementRef, HostListener, OnInit } from '@angular/core';
import { BaseSearchComponent } from '../classes/BaseSearchComponent';
import { SearchService } from '../search.service';
import { ThemeService } from '../theme.service';
import { Log } from '../helpers/Log';

@Component({
  selector: 'app-nav-search-bar',
  templateUrl: './nav-search-bar.component.html',
  styleUrls: ['./nav-search-bar.component.scss'],
  providers: [ ThemeService, SearchService ]
})
export class NavSearchBarComponent extends BaseSearchComponent implements OnInit {

  @HostListener('document:click', ['$event'])
  clickout(event) {
    if (!event || !event.target) {
      return;
    }
    try {
      if (this.elementRef && this.elementRef.nativeElement && !this.elementRef.nativeElement.contains(event.target)) {
        this.showSuggestions = false;
      }
    } catch (e) {
    // Ignore permission errors from cross-origin iframes or restricted contexts
    }
  }

  constructor(
    private elementRef: ElementRef,
    protected themeService: ThemeService,
    protected searchService: SearchService
  ) {
    super(themeService, searchService);
  }

  ngOnInit() {
    this.selectedItemType = "all";
    this.inputValue = this.query;
    if(this.inputValue != "") {
      this.getSuggestions();
    }
  }

  resetSearch() {
    this.query = "";
    this.inputValue = "";
    this.suggestions = [];
  }

  getPlaceholderText(): string {
    try {
      if (typeof window !== 'undefined' && window && window.innerWidth) {
        return window.innerWidth > 605 ?
          this.getString('searchPlaceholder') : this.getString('search');
      }
    } catch (e) {
      // Fallback if window.innerWidth is not accessible (e.g., in restricted contexts)
      Log.getInstance().d('Error accessing window.innerWidth in getPlaceholderText: ' + (e.message || String(e)));
    }
    // Fallback: return the shorter placeholder text
    return this.getString('search');
  }

}
